module.exports = __webpack_public_path__ + "static/media/bus.0c7ef2c7.svg";